const config = {
    ENVIRONMENT_TYPE: '#{EnvironmentType}',
    APPLICATION_NAME: 'TicketSolutions.Insights.Client',
    APPLICATION_VERSION: '#{ApplicationVersion}',
    API_URI: '#{ApiUri}',
    IMAGE_BASE_URI: '#{ImageBaseUri}',
    SIGNALR_URI: '#{SignalrUri}',
    GOOGLE_ANALYTICS: '#{GoogleAnalytics}',
    IDENTITY_AUTHORITY: '#{IdentityClientAuthority}',
    IDENTITY_CLIENT_ID: '#{IdentityClientImplicitClientId}',
    OID_LOG_LEVEL: 'NONE',
    APPS_BASE_URL: '#{AppsBaseUrl}',
    APPS_LOCALTIX_BASE_URL: '#{AppsLocaltixBaseUrl}',
    BRAND_ASSETS: JSON.parse("{" +
        "\"Cobrand\": {" +
            "\"PrimaryLogo3Url\": \"#{CobrandPrimaryLogo3Url}\"," +
            "\"IconLogo3Url\":\"#{CobrandIconLogo3Url}\"" +
        "}}"),
}

export default config
